import React, { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { savePlanDataBff } from "../../api/PupilApi";
import { useContextSelector } from "use-context-selector";
import { StateContext } from "../../contexts/StateContext";

const SignupForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { planType, planDes, planDuration, planCost, planName, planStatus } =
    location.state;

  const isLoggedIn = useContextSelector(
    StateContext,
    (state) => state.isLoggedIn
  );

  // Removed unused `setIsLoggedIn`

  const [chitCount, setChitCount] = useState(1);

  const [planRequest] = useState({
    planData: {
      planType: planType,
      planDes: planDes,
      planDuration: planDuration,
      planName: planName,
      planStatus: planStatus,
      planCost: planCost,
    },
    chitCount: 1,
  });

  const [formData] = useState({
    username: "",
    email: "",
    mobile: "",
    scheme1: false,
    scheme2: false,
    scheme3: false,
    planType: planType,
    planDes: planDes,
    planDuration: planDuration,
  });

  // Removed unused setErrorMessage, schemePrices, handleChange

  const calculateTotalAmount = () => {
    return planCost * chitCount;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log({ ...formData, totalAmount: calculateTotalAmount() });
  };

  const planOrderData = (e) => {
    e.preventDefault();
    planRequest.chitCount = chitCount;
    savePlanDataBff(planRequest)
      .then((res) => {
        toast(res.message);
        navigate("/plansuccess");
      })
      .catch((error) => {
        if (error.message) {
          toast(error.message);
        } else {
          toast("Sorry! Something went wrong. Please try again!");
        }
        console.log(error);
      });
  };

  if (isLoggedIn) {
    return (
      <div className="container mx-auto mt-6 flex justify-center items-center">
        <div className="bg-white shadow-md p-8 rounded-md w-full max-w-md">
          <h2 className="text-2xl font-semibold mb-4">Chit Scheme</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-2">
              <div className="flex items-center gap-2 text-[#767676] relative">
                <label className="block">Select number of Chit:</label>
                <select
                  onChange={(event) => setChitCount(event.target.value)}
                  id="countries"
                  className="w-16 md:w-20 border-[1px] border-gray-200 py-1 px-4 cursor-pointer text-primeColor text-base block dark:placeholder-gray-400 appearance-none focus-within:outline-none focus-visible:border-primeColor"
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>

            <div className="flex flex-col gap-.5">
              <p className="font-titleFont text-base font-semibold text-gray-600">
                Total Amount:
              </p>
              <input
                type="text"
                id="totalAmount"
                name="totalAmount"
                value={calculateTotalAmount()}
                className="w-full h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal rounded-md border-[1px] border-gray-400 outline-none"
                readOnly
              />
            </div>

            <button
              onClick={planOrderData}
              className="w-full mt-3 text-white bg-blue-500 text-base font-medium h-10 rounded-md hover:bg-blue-700 hover:text-white duration-300"
            >
              Buy Plan
            </button>
          </form>
        </div>
        <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            error: {
              duration: 6000,
              style: {
                background: "#FF4136",
                color: "#fff",
              },
            },
            success: {
              duration: 6000,
              style: {
                background: "#008000",
                color: "#fff",
              },
            },
          }}
        />
      </div>
    );
  } else {
    return <Navigate to={"/signup/" + "You are not logged in please signup or login."} replace />;
  }
};

export default SignupForm;
